export default __webpack_public_path__ + "static/media/userOrder.27d7341e.svg";